export const ROUTER_PATHS = {
  HOME: "/",
  SETTINGS: "settings",
  // PROJECTS: {
  //   INDEX: "projects",
  //   DETAILS: (id = ":id") => id,
  // },
  AUTH: {
    INDEX: "auth",
  },
  PERMISSIONS: "permissions",
} as const;

export function getFullPath(...segments: string[]): string {
  if (segments.toString() === "/") {
    return "/";
  }
  return "/" + segments.join("/");
}

const ABSOLUTE_SYMBOL = "/";

export const absolutePath = (path: string): string => `/${path}`;

export const pathWithParams = (
  ...params: Array<string | number | null | undefined>
) =>
  ABSOLUTE_SYMBOL +
  params
    .filter((p) => {
      if (!p) {
        console.warn(`param is ${p}`);
        return false;
      }

      return true;
    })
    .join(ABSOLUTE_SYMBOL);
